import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../httpClient/RestApiService';

export type EditFieldDescriptionRequestParams = {
  readonly datasourceLuid: string;
  readonly fullyQualifiedFieldName: string;
  readonly description: string;
}

export type EditFieldDescriptionRequestBody = {
  readonly 'fully_qualified_field_name': string;
  readonly 'field_edit_model': {
    readonly 'user_description_text': string;
  };
};

export type EditFieldDescriptionErrorResponse = {
  'message': string;
  'httpErrorCode': number;
}

export type EditFieldDescriptionResponse = EditFieldDescriptionErrorResponse | {};

export function getEditFieldDescriptionRequestConfig(params: EditFieldDescriptionRequestParams): JsonRestApiRequestConfig {
  return {
    restApiVersion: '-', // TAG api "version" string is -
    httpMethod: 'PATCH',
    endpoint: `datasourcemodel/datasources/${params.datasourceLuid}/field`,
    serverWideRequest: true
  };
}

function getEditFieldDescriptionRequestBody({fullyQualifiedFieldName: fieldFullyQualifiedName, description}: EditFieldDescriptionRequestParams): EditFieldDescriptionRequestBody {
  return {
    'fully_qualified_field_name': fieldFullyQualifiedName,
    'field_edit_model': {
      'user_description_text': description
    }
  };
}

export function callViaApiService(params: EditFieldDescriptionRequestParams) {
  return makeJsonRestApiRequest<EditFieldDescriptionRequestBody, EditFieldDescriptionErrorResponse>({
    config: getEditFieldDescriptionRequestConfig(params),
    request: getEditFieldDescriptionRequestBody(params),
  });
}
